import React, { useState } from 'react'
import { DossierPdfFieldName } from '../../helpers/Constants';
import { Button } from '@mui/material';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import DeleteSweepOutlinedIcon from '@mui/icons-material/DeleteSweepOutlined';
/**
/**
 * @typedef {Object} ProjectOperationsPlanningUploadProps
  * @property {CpscRequest} cpscRequest
  * @property {downloadPdfCallback} downloadPdf
  * @property {downloadPdfCallback} mobileDownloadPdf
  * @property {uploadPdfCallback} uploadPdf
  * @property {deletePdfCallback} deletePdf
  * @property {boolean} readOnly
 */

/**
 * @param {ProjectOperationsPlanningUploadProps}  props
 * @return {import('react').ReactElement}
 */
function ProjectOperationsPlanningUpload(props) {
  const [projectOperationsPlanningObjectUrl, setProjectOperationsPlanningObjectUrl] = useState(null);



  const handleFileChange = (event) => {
    event.persist()
    const file = event.target.files[0]
    let document = {}
    document.name = file.name;

    if (event.target.files.length === 0) return
    const formData = new FormData()
    formData.append("uploadedFile", event.target.files[0]);
    props.uploadPdf(formData, DossierPdfFieldName.ProjectOperationsPlanning);
    setProjectOperationsPlanningObjectUrl(undefined)
    event.target.value = null
  }

  const previewFile = async (event) => {
    const url = await props.downloadPdf(DossierPdfFieldName.ProjectOperationsPlanning)
    setProjectOperationsPlanningObjectUrl(url)
  }
  const mobilePreviewFile = async (event) => {
    const url = await props.mobileDownloadPdf(DossierPdfFieldName.ProjectOperationsPlanning)
    setProjectOperationsPlanningObjectUrl(url)
  }
  const deleteFile = async (event) => {
    await props.deletePdf(DossierPdfFieldName.ProjectOperationsPlanning)
    setProjectOperationsPlanningObjectUrl(undefined)

  }

  return (
    <>
      <div className='content-desktop'>
        <div className="file-card">

          <div className="file-inputs">
            <input className='upload-input' id="projectOperationsPlanningSlideUploaded" type="file" onChange={handleFileChange} accept="application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" disabled={props.readOnly} />
            <Button variant='contained' color='secondary' className='upload-btn ' disabled={props.readOnly} >
              <CloudUploadOutlinedIcon />&nbsp; Upload
            </Button>
          </div>

          <p className="main">Supported files</p>
          <p className="info">PDF, Excel</p>

        </div>
        <div>
          {props.cpscRequest.projectOperationsPlanningSlideUploaded &&

            <div>

              <div className='files' >
                <div className='file-name'>Project Operations Planning Slide Upload</div>
                <div className='dld-file'> <Button variant='contained' color='success' disabled={!props.cpscRequest.projectOperationsPlanningSlideUploaded}
                  onClick={previewFile}><RemoveRedEyeOutlinedIcon /> &nbsp;View</Button></div>
                <div className='del-file'>
                  <Button variant='contained' color='error' onClick={() => { deleteFile() }}
                    disabled={!props.cpscRequest.projectOperationsPlanningSlideUploaded || props.readOnly}>
                    <DeleteSweepOutlinedIcon /> &nbsp;Delete</Button>
                </div>
              </div>


              {projectOperationsPlanningObjectUrl && <iframe src={projectOperationsPlanningObjectUrl} height="700" width="100%" title="Invoice" style={{ paddingBottom: '15px' }}></iframe>}
            </div>
          }
        </div>
      </div>
      <div className='content-mobile'>
        <div className="mobile-file-card">

          <div className="file-inputs">
            <input className='upload-input' id="projectOperationsPlanningSlideUploaded" type="file" onChange={handleFileChange} accept="application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" disabled={props.readOnly} />
            <Button variant='contained' color='secondary' className='upload-btn ' disabled={props.readOnly} >
              <CloudUploadOutlinedIcon />&nbsp; Upload
            </Button>
          </div>

          <p className="main">Supported files</p>
          <p className="info">PDF, Excel</p>

        </div>
        <div>
          {props.cpscRequest.projectOperationsPlanningSlideUploaded &&

            <div>

              <div className='files' >
                <div className='mobile-file-name'>Project Operations Planning Slide Upload</div><br />
                <div >
                  <div >
                    <Button style={{ width: '100%' }} variant='contained' color='success' disabled={!props.cpscRequest.projectOperationsPlanningSlideUploaded} onClick={mobilePreviewFile}> <RemoveRedEyeOutlinedIcon /> &nbsp;View</Button></div>

                  <div >
                    <br />
                    <Button style={{ width: '100%' }} variant='contained' color='error' onClick={() => { deleteFile() }}
                      disabled={!props.cpscRequest.projectOperationsPlanningSlideUploaded || props.readOnly}>
                      <DeleteSweepOutlinedIcon /> &nbsp; Delete </Button>
                  </div>
                </div>
              </div>
            </div>


          }
        </div>
      </div>

    </>
  )
}

export default ProjectOperationsPlanningUpload